import * as GLOBAL_LABELS from "../labels/global";

export const LABELS = {
    [GLOBAL_LABELS.GLOBAL_DELETE]: "Delete",
    [GLOBAL_LABELS.GLOBAL_CANCEL]: "Cancel",
    [GLOBAL_LABELS.GLOBAL_UNKNOWN]: "Unknown",

    [GLOBAL_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_TEST_MODE]: "Test mode",
    [GLOBAL_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_LIVE_TEST_MODE]: "Live test mode",
    [GLOBAL_LABELS.GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_MESSAGE]: "This checkout is in {mode}. No actual payment will be made.",
    [GLOBAL_LABELS.GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_BUTTON]: "I understand",
};

export default LABELS;
